import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {TableModule} from 'primeng/table';
import {AuthenticationService} from './authentication.service';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AuthGuard} from './auth/auth.guard';
import {AuthService} from './auth/auth.service';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {MatSidenavModule} from '@angular/material/sidenav';
import * as $ from 'jquery';
import {ToastrModule} from 'ngx-toastr';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ApiPrefixInterceptorService} from './building-blocks/interceptor/api-prefix-interceptor.service';
import {HttpTokenInterceptorService} from './building-blocks/interceptor/http-token-interceptor.service';
import { NoCacheSrcDirective } from './building-blocks/directive/no-cache-src.directive';
import {DecimalPipe} from '@angular/common';

@NgModule({
    declarations: [
        AppComponent,
        NoCacheSrcDirective
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        TableModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        SelectDropDownModule,
        MatSidenavModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot()
    ],
    providers: [
        AuthenticationService,
        AuthGuard,
        AuthService,
        DecimalPipe,
        {provide: HTTP_INTERCEPTORS, useClass: ApiPrefixInterceptorService, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptorService, multi: true},

    ],
    bootstrap: [AppComponent]
})
export class AppModule {

}
